import { ReactElement, useContext } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Col, Row, Statistic, Divider } from 'antd';
import { Typography } from 'iglooform';
import './policy-detail.less';
import { StatusBox } from 'iglooform';
import { PolicyStatus, PolicyStatusType } from '@/utils/status';
import { getImageUrl } from '@/service';
import moment from 'moment';
import { useEffect } from 'react';
import { useState } from 'react';
import Context from '@/utils/context';
import { images } from '@/assets/images';
import DynamicItem from '../dynamic-item';

const currentLang = localStorage.getItem('selected_lang');

const TurboConfigDetail = (value: any) => {
  const { elements, detailConfig, label } = value;
  const { formatMessage: originalFormatMessage } = useIntl();
  const { isPc } = useContext(Context);
  const [vehicleImage, setVehicleImage] = useState<any[]>();

  const formatMessage = ({ id }: { id: string | undefined }) => {
    return id ? originalFormatMessage({ id }) : '';
  };

  useEffect(() => {
    let chassisImage = new Promise(async (resolve, reject) => {
      if (detailConfig?.chassis_or_engine_image?.length > 0) {
        if (detailConfig?.chassis_or_engine_image[0]?.includes(API_URL)) {
          const res = await getImageUrl(
            detailConfig?.chassis_or_engine_image[0],
          );
          resolve({
            name: 'chassis_or_engine_image',
            url: res.url,
          });
        } else {
          resolve({
            name: 'chassis_or_engine_image',
            url: detailConfig?.chassis_or_engine_image[0],
          });
        }
      }
    });
    let vehicleFront = new Promise(async (resolve, reject) => {
      if (detailConfig?.vehicle_front?.length > 0) {
        if (detailConfig?.vehicle_front[0]?.includes(API_URL)) {
          const res = await getImageUrl(detailConfig?.vehicle_front[0]);
          resolve({
            name: 'vehicle_front',
            url: res.url,
          });
        } else {
          resolve({
            name: 'vehicle_front',
            url: detailConfig?.vehicle_front[0],
          });
        }
      }
    });
    let vehicleLeft = new Promise(async (resolve, reject) => {
      if (detailConfig?.vehicle_left?.length > 0) {
        if (detailConfig?.vehicle_left[0]?.includes(API_URL)) {
          const res = await getImageUrl(detailConfig?.vehicle_left[0]);
          resolve({
            name: 'vehicle_left',
            url: res.url,
          });
        } else {
          resolve({
            name: 'vehicle_left',
            url: detailConfig?.vehicle_left[0],
          });
        }
      }
    });
    let vehicleRear = new Promise(async (resolve, reject) => {
      if (detailConfig?.vehicle_rear?.length > 0) {
        if (detailConfig?.vehicle_rear[0]?.includes(API_URL)) {
          const res = await getImageUrl(detailConfig?.vehicle_rear[0]);
          resolve({
            name: 'vehicle_rear',
            url: res.url,
          });
        } else {
          resolve({
            name: 'vehicle_rear',
            url: detailConfig?.vehicle_rear[0],
          });
        }
      }
    });
    let vehicleRight = new Promise(async (resolve, reject) => {
      if (detailConfig?.vehicle_right?.length > 0) {
        if (detailConfig?.vehicle_right[0]?.includes(API_URL)) {
          const res = await getImageUrl(detailConfig?.vehicle_right[0]);
          resolve({
            name: 'vehicle_right',
            url: res.url,
          });
        } else {
          resolve({
            name: 'vehicle_right',
            url: detailConfig?.vehicle_right[0],
          });
        }
      }
    });
    let vinImage = new Promise(async (resolve, reject) => {
      if (detailConfig?.vin_image?.length > 0) {
        if (detailConfig?.vin_image[0]?.includes(API_URL)) {
          const res = await getImageUrl(detailConfig?.vin_image[0]);
          resolve({
            name: 'vin_image',
            url: res.url,
          });
        } else {
          resolve({
            name: 'vin_image',
            url: detailConfig?.vin_image[0],
          });
        }
      }
    });

    if (detailConfig?.vin_image?.length > 0) {
      Promise.all([
        vehicleFront,
        vehicleLeft,
        vehicleRear,
        vehicleRight,
        vinImage,
      ]).then((result) => {
        setVehicleImage(result);
      });
    } else {
      Promise.all([
        chassisImage,
        vehicleFront,
        vehicleLeft,
        vehicleRear,
        vehicleRight,
      ]).then((result) => {
        setVehicleImage(result);
      });
    }
  }, []);

  const vehicleName = [
    'vehicle_front',
    'vehicle_rear',
    'vehicle_left',
    'vehicle_right',
    'chassis_or_engine_image',
    'vin_image',
  ];
  if (label === 'Policy' || label === 'Policy Details') return null;
  if (!isPc) {
    return (
      <>
        <div className="item">
          <Typography
            level="h4"
            style={{ display: 'block', marginBottom: '12px' }}
          >
            {formatMessage({ id: label })}
          </Typography>
        </div>
        {elements &&
          elements.length > 0 &&
          elements.map((value: any, index: number) => {
            if (value.type === 'Typography') {
              return;
            }
            if (!detailConfig[value.name]) return;
            if (vehicleName.indexOf(value.name) >= 0 && vehicleImage) {
              let component: any;
              vehicleImage?.map((val: any) => {
                if (val.name === value.name) {
                  component = (
                    <div style={{ marginBottom: 8 }}>
                      <Typography
                        level="body2"
                        className="title"
                        wrapElement="div"
                      >
                        {formatMessage({ id: value.label })}
                      </Typography>
                      <Typography level="body2">
                        <a onClick={() => window.open(val.url)}>
                          {formatMessage({ id: 'View' })}
                        </a>
                      </Typography>
                    </div>
                  );
                }
              });

              return component;
            }
            if (value.type === 'PhoneNumber') {
              const v = detailConfig[value.name];
              if (!v.phoneNumber) {
                return null;
              }
              return (
                <div className="item" key={index}>
                  <Typography level="body2" className="title" wrapElement="div">
                    {formatMessage({ id: value.label })}
                  </Typography>
                  <Typography level="body2">
                    {value.areaCode} {v.phoneNumber}
                  </Typography>
                </div>
              );
            }
            if (value.options) {
              const v = detailConfig[value.name];
              const displayValue = value.options.find(
                (option: any) => option.value === v,
              )?.label;
              return (
                <div style={{ marginBottom: 8 }} key={index}>
                  <Typography level="body2" className="title" wrapElement="div">
                    {formatMessage({ id: value.label })}
                  </Typography>
                  <Typography level="body2">
                    {formatMessage({ id: displayValue })}
                  </Typography>
                </div>
              );
            }

            if (value.type === 'DatePicker') {
              if (
                value.label === 'Policy Start Date' ||
                value.label === 'Policy End Date'
              )
                return;
              return (
                <div className="item" key={index}>
                  <Typography level="body2" className="title" wrapElement="div">
                    {formatMessage({ id: value.label })}
                  </Typography>
                  <Typography level="body2">
                    {moment(detailConfig[value.name]).format('DD / MM / YYYY')}
                  </Typography>
                </div>
              );
            }
            if (value.type === 'Select' && value.datasourceKey) {
              return (
                <DynamicItem
                  config={value}
                  formValue={detailConfig}
                  isPc={false}
                  key={index}
                />
              );
            }
            if (value.type === 'AddableSection') {
              const arrVal = detailConfig[value.name];
              return arrVal.map((item: Record<string, any>, idx: number) => {
                return (
                  <>
                    <Typography level="h4" className="addableSubTitle">
                      {formatMessage({ id: value.label })} {idx + 1}
                    </Typography>
                    {value.elements.map((ele: any, idx: number) => {
                      if (!item[ele?.name]) return;
                      if (ele.options) {
                        const v = item[ele?.name];
                        const displayValue = ele.options.find(
                          (option: any) => option.value === v,
                        )?.label;
                        return (
                          <div style={{ marginBottom: 8 }} key={idx}>
                            <Typography
                              level="body2"
                              className="title"
                              wrapElement="div"
                            >
                              {formatMessage({ id: ele.label })}
                            </Typography>
                            <Typography level="body2">
                              {formatMessage({ id: displayValue })}
                            </Typography>
                          </div>
                        );
                      }
                      if (ele.type === 'PhoneNumber') {
                        const v = item[ele?.name];
                        if (!v.phoneNumber) {
                          return null;
                        }
                        return (
                          <div style={{ marginBottom: 8 }} key={idx}>
                            <Typography
                              level="body2"
                              className="title"
                              wrapElement="div"
                            >
                              {formatMessage({ id: ele.label })}
                            </Typography>
                            <Typography level="body2">
                              {ele.areaCode} {v.phoneNumber}
                            </Typography>
                          </div>
                        );
                      }
                      if (ele.type === 'DatePicker') {
                        return (
                          <div style={{ marginBottom: 8 }} key={idx}>
                            <Typography
                              level="body2"
                              className="title"
                              wrapElement="div"
                            >
                              {formatMessage({ id: ele.label })}
                            </Typography>
                            <Typography level="body2">
                              {moment(item[ele?.name]).format('DD / MM / YYYY')}
                            </Typography>
                          </div>
                        );
                      }
                      if (ele.type === 'Select' && ele.datasourceKey) {
                        return (
                          <DynamicItem
                            config={ele}
                            formValue={item}
                            isPc={false}
                            key={idx}
                          />
                        );
                      }
                      return (
                        <div style={{ marginBottom: 8 }} key={idx}>
                          <Typography
                            level="body2"
                            className="title"
                            wrapElement="div"
                          >
                            {formatMessage({ id: ele.label })}
                          </Typography>
                          <Typography level="body2">
                            {item[ele?.name]}
                          </Typography>
                        </div>
                      );
                    })}
                  </>
                );
              });
            }
            return (
              <div className="item" key={index}>
                <Typography level="body2" className="title" wrapElement="div">
                  {formatMessage({ id: value.label })}
                </Typography>
                <Typography level="body2">
                  {detailConfig[value.name]}
                </Typography>
              </div>
            );
          })}
      </>
    );
  }

  return (
    <Row
      gutter={[16, 0]}
      className="detailBottomBox"
      style={{ paddingTop: '0', paddingBottom: '0' }}
    >
      <Col span={24}>
        <Typography
          level="h4"
          style={{ display: 'block', marginBottom: '16px' }}
        >
          {formatMessage({ id: label })}
        </Typography>
      </Col>
      {elements &&
        elements.length > 0 &&
        elements.map((value: any, index: number) => {
          if (value.type === 'Typography') {
            return;
          }
          if (!detailConfig[value.name]) return;
          if (vehicleName.indexOf(value.name) >= 0 && vehicleImage) {
            let component: any;
            vehicleImage?.map((val: any) => {
              if (val.name === value.name) {
                component = (
                  <Col span={6} style={{ marginBottom: '16px' }}>
                    <Typography
                      level="body1"
                      className="title"
                      wrapElement="div"
                    >
                      {formatMessage({ id: value.label })}
                    </Typography>
                    <Typography level="body1">
                      <a onClick={() => window.open(val.url)}>
                        {formatMessage({ id: 'View' })}
                      </a>
                    </Typography>
                  </Col>
                );
              }
            });
            return component;
          }
          if (value.type === 'PhoneNumber') {
            const v = detailConfig[value.name];
            if (!v.phoneNumber) {
              return null;
            }
            return (
              <Col span={6} style={{ marginBottom: '16px' }} key={index}>
                <Typography level="body1" className="title">
                  {formatMessage({ id: value.label })}
                </Typography>
                <Typography level="body1">
                  {value.areaCode} {v.phoneNumber}
                </Typography>
              </Col>
            );
          }
          if (value.options) {
            const v = detailConfig[value.name];
            const displayValue = value.options.find(
              (option: any) => option.value === v,
            )?.label;
            return (
              <Col span={6} style={{ marginBottom: '16px' }} key={index}>
                <Typography level="body1" className="title">
                  {formatMessage({ id: value.label })}
                </Typography>
                <Typography level="body1">
                  {formatMessage({ id: displayValue })}
                </Typography>
              </Col>
            );
          }

          if (value.type === 'DatePicker') {
            if (
              value.label === 'Policy Start Date' ||
              value.label === 'Policy End Date'
            )
              return;
            return (
              <Col span={6} style={{ marginBottom: '16px' }} key={index}>
                <Typography level="body1" className="title">
                  {formatMessage({ id: value.label })}
                </Typography>
                <Typography level="body1">
                  {moment(detailConfig[value.name]).format('DD / MM / YYYY')}
                </Typography>
              </Col>
            );
          }
          if (value.type === 'Select' && value.datasourceKey) {
            return (
              <DynamicItem
                config={value}
                formValue={detailConfig}
                isPc={true}
                key={index}
              />
            );
          }
          if (value.type === 'AddableSection') {
            const arrVal = detailConfig[value.name];
            return arrVal.map((item: Record<string, any>, idx: number) => {
              return (
                <>
                  <Typography level="h4" className="addableSubTitle">
                    {formatMessage({ id: value.label })} {idx + 1}
                  </Typography>
                  {value.elements.map((ele: any, idx: number) => {
                    if (!item[ele?.name]) return;
                    if (ele.options) {
                      const v = item[ele?.name];
                      const displayValue = ele.options.find(
                        (option: any) => option.value === v,
                      )?.label;
                      return (
                        <Col
                          span={6}
                          style={{ marginBottom: '16px' }}
                          key={idx}
                        >
                          <Typography level="body1" className="title">
                            {formatMessage({ id: ele.label })}
                          </Typography>
                          <Typography level="body1">
                            {formatMessage({ id: displayValue })}
                          </Typography>
                        </Col>
                      );
                    }
                    if (ele.type === 'PhoneNumber') {
                      const v = item[ele?.name];
                      if (!v.phoneNumber) {
                        return null;
                      }
                      return (
                        <Col
                          span={6}
                          style={{ marginBottom: '16px' }}
                          key={idx}
                        >
                          <Typography level="body1" className="title">
                            {formatMessage({ id: ele.label })}
                          </Typography>
                          <Typography level="body1">
                            {ele.areaCode} {v.phoneNumber}
                          </Typography>
                        </Col>
                      );
                    }
                    if (ele.type === 'DatePicker') {
                      return (
                        <Col
                          span={6}
                          style={{ marginBottom: '16px' }}
                          key={idx}
                        >
                          <Typography level="body1" className="title">
                            {formatMessage({ id: ele.label })}
                          </Typography>
                          <Typography level="body1">
                            {moment(item[ele?.name]).format('DD / MM / YYYY')}
                          </Typography>
                        </Col>
                      );
                    }
                    if (ele.type === 'Select' && ele.datasourceKey) {
                      return (
                        <DynamicItem
                          config={ele}
                          formValue={item}
                          isPc={true}
                          key={idx}
                        />
                      );
                    }
                    return (
                      <Col span={6} style={{ marginBottom: '16px' }} key={idx}>
                        <Typography level="body1" className="title">
                          {formatMessage({ id: ele.label })}
                        </Typography>
                        <Typography level="body1">{item[ele?.name]}</Typography>
                      </Col>
                    );
                  })}
                </>
              );
            });
          }
          return (
            <Col span={6} style={{ marginBottom: '16px' }} key={index}>
              <Typography level="body1" className="title">
                {formatMessage({ id: value.label })}
              </Typography>
              <Typography level="body1">
                {formatMessage({ id: detailConfig[value.name] })}
              </Typography>
            </Col>
          );
        })}
      <Divider style={{ marginTop: '8px', marginBottom: '24px' }} />
    </Row>
  );
};

const PolicyDetail = (props: any): ReactElement => {
  const { policyDetail, policyDetailConfig } = props;
  const { elements } = policyDetailConfig?.form?.default;
  const { formatMessage } = useIntl();
  // const [ePolicyUrl, setEPolicyUrl] = useState<UrlType>();
  const [url, setUrl] = useState<string>();
  const { isPc } = useContext(Context);

  useEffect(() => {
    if (
      policyDetail?.product?.logo_url &&
      policyDetail?.product?.logo_url?.includes(API_URL)
    ) {
      getImageUrl(policyDetail?.product?.logo_url).then((res) => {
        setUrl(res?.url);
      });
    }
    setUrl(policyDetail?.product?.logo_url);
  }, []);

  if (!isPc) {
    return (
      <>
        <div className="policyDetailBox_h5">
          <div className="detailTopBox_h5">
            <img src={images.tob_icon} alt="" className="icon" />
            <div style={{ float: 'left' }}>
              <Typography level="h4" className="product" wrapElement="div">
                {policyDetail?.plan?.name}
              </Typography>
              <StatusBox
                type={PolicyStatusType[policyDetail.state]}
                className="state"
              >
                <FormattedMessage {...PolicyStatus[policyDetail?.state]} />
              </StatusBox>
            </div>
          </div>
          <Divider style={{ marginTop: '16px', marginBottom: '8px' }} />
          <Typography level="h4" wrapElement="div" style={{ marginBottom: 12 }}>
            {formatMessage({ id: 'Policy Information' })}
          </Typography>
          <div className="item">
            <Typography level="body2" className="title" wrapElement="div">
              {formatMessage({ id: 'Policy ID' })}
            </Typography>
            <Typography level="body2">{policyDetail.display_id}</Typography>
          </div>
          <div className="item">
            <Typography level="body2" className="title" wrapElement="div">
              {formatMessage({ id: 'Annual Premium' })}
            </Typography>
            <Typography level="body1">
              <Statistic
                value={policyDetail.premium}
                suffix={formatMessage({ id: 'VND' })}
                groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
                decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
                valueStyle={{ fontSize: '14px' }}
              />
            </Typography>
          </div>
          <div className="item">
            <Typography level="body2" className="title" wrapElement="div">
              {formatMessage({ id: 'Policy Holder' })}
            </Typography>
            <Typography level="body2">
              {policyDetail?.policy_holder?.full_name}
            </Typography>
          </div>
          <div className="item">
            <Typography level="body2" className="title" wrapElement="div">
              {formatMessage({ id: 'Policy Start Date' })}
            </Typography>
            <Typography level="body2">
              {moment(policyDetail?.start_at * 1000).format('DD / MM / YYYY')}
            </Typography>
          </div>
          <div className="item">
            <Typography level="body2" className="title" wrapElement="div">
              {formatMessage({ id: 'Policy End Date' })}
            </Typography>
            <Typography level="body2">
              {moment(policyDetail?.end_at * 1000).format('DD / MM / YYYY')}
            </Typography>
          </div>
          {policyDetail.coi_files.length > 0 && (
            <div className="item">
              <Typography level="h4" style={{ display: 'block' }}>
                {formatMessage({ id: 'Epolicy' })}
              </Typography>
              {policyDetail?.coi_files &&
                policyDetail?.coi_files.length > 0 &&
                policyDetail.coi_files.map((value: any) => {
                  return (
                    <div className="item">
                      <Typography
                        level="body2"
                        style={{
                          display: 'block',
                          marginBottom: '4px',
                          color: '#666666',
                        }}
                      >
                        {formatMessage({ id: 'E-Policy' })}
                      </Typography>
                      <Typography level="body2">
                        <a onClick={() => window.open(value?.url)}>
                          {value?.name}
                        </a>
                      </Typography>
                    </div>
                  );
                })}
            </div>
          )}
          {elements &&
            elements.length > 0 &&
            policyDetail?.form &&
            elements.map((value: any) => {
              return (
                <TurboConfigDetail
                  elements={value.elements}
                  detailConfig={policyDetail?.form[value.name]}
                  label={value.label}
                />
              );
            })}
        </div>
      </>
    );
  }

  return (
    <>
      <div className="policyDetailBox">
        <div className="detailTopBox">
          {url && <img src={url} alt="" className="icon" />}
          <Typography level="h4" className="product">
            {policyDetail?.plan?.name}
          </Typography>
          <StatusBox
            type={PolicyStatusType[policyDetail.state]}
            className="state"
          >
            <FormattedMessage {...PolicyStatus[policyDetail?.state]} />
          </StatusBox>
        </div>
        <Row
          className="listBottomBox"
          style={{ padding: '24px' }}
          gutter={[16, 0]}
        >
          <Col span={6} style={{ marginBottom: '16px' }}>
            <Typography
              level="body1"
              style={{
                display: 'block',
                marginBottom: '4px',
                color: '#666666',
              }}
            >
              {formatMessage({ id: 'Policy Number' })}
            </Typography>
            <Typography level="body1">{policyDetail.display_id}</Typography>
          </Col>
          <Col span={6} style={{ marginBottom: '16px' }}>
            <Typography
              level="body1"
              style={{
                display: 'block',
                marginBottom: '4px',
                color: '#666666',
              }}
            >
              {formatMessage({ id: 'Annual Premium' })}
            </Typography>
            <Typography level="body1">
              <Statistic
                value={policyDetail.premium}
                suffix={formatMessage({ id: 'VND' })}
                groupSeparator={currentLang === 'vi-VN' ? '.' : ','}
                decimalSeparator={currentLang === 'vi-VN' ? ',' : '.'}
              />
            </Typography>
          </Col>
          <Col span={6} style={{ marginBottom: '16px' }}>
            <Typography
              level="body1"
              style={{
                display: 'block',
                marginBottom: '4px',
                color: '#666666',
              }}
            >
              {formatMessage({ id: 'Policy Holder' })}
            </Typography>
            <Typography level="body1">
              {policyDetail?.policy_holder?.full_name}
            </Typography>
          </Col>
          <Col span={6} style={{ marginBottom: '16px' }}>
            <Typography
              level="body1"
              style={{
                display: 'block',
                marginBottom: '4px',
                color: '#666666',
              }}
            >
              {formatMessage({ id: 'Policy Start Date' })}
            </Typography>
            <Typography level="body1">
              {moment(policyDetail?.start_at * 1000).format('DD / MM / YYYY')}
            </Typography>
          </Col>
          <Col span={6} style={{ marginBottom: '16px' }}>
            <Typography
              level="body1"
              style={{
                display: 'block',
                marginBottom: '4px',
                color: '#666666',
              }}
            >
              {formatMessage({ id: 'Policy End Date' })}
            </Typography>
            <Typography level="body1">
              {moment(policyDetail?.end_at * 1000).format('DD / MM / YYYY')}
            </Typography>
          </Col>
          {policyDetail?.meta?.applicant && (
            <Col span={6} style={{ marginBottom: '16px' }}>
              <Typography
                level="body1"
                style={{
                  display: 'block',
                  marginBottom: '4px',
                  color: '#666666',
                }}
              >
                {formatMessage({ id: 'Plan' })}
              </Typography>
              <Typography level="body1">
                {formatMessage({ id: policyDetail.meta.applicant })}
              </Typography>
            </Col>
          )}

          {policyDetail?.coi_files?.length > 0 && (
            <Divider style={{ marginBottom: '24px', marginTop: '8px' }} />
          )}
          {policyDetail?.coi_files?.length > 0 && (
            <Col span={24} style={{ marginBottom: '16px' }}>
              <Typography level="h4" style={{ display: 'block' }}>
                {formatMessage({ id: 'Epolicy' })}
              </Typography>
            </Col>
          )}
          {policyDetail?.coi_files &&
            policyDetail?.coi_files.length > 0 &&
            policyDetail.coi_files.map((value: any) => {
              return (
                <Col span={6} style={{ marginBottom: '16px' }}>
                  <Typography
                    level="body1"
                    style={{
                      display: 'block',
                      marginBottom: '4px',
                      color: '#666666',
                    }}
                  >
                    {formatMessage({ id: 'E-Policy' })}
                  </Typography>
                  <Typography level="body1">
                    <a onClick={() => window.open(value?.url)}>{value?.name}</a>
                  </Typography>
                </Col>
              );
            })}
          <Divider style={{ marginTop: '8px', marginBottom: '24px' }} />
        </Row>
        {elements &&
          elements.length > 0 &&
          policyDetail?.form &&
          elements.map((value: any) => {
            return (
              <TurboConfigDetail
                elements={value.elements}
                detailConfig={policyDetail?.form[value.name]}
                label={value.label}
              />
            );
          })}
      </div>
    </>
  );
};

export default PolicyDetail;
